/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react"

const PreglediTable = () => (
  <table className="table-first-bold">
    <tbody>
      <tr>
        <th>&nbsp;</th>
        <th>Razlog</th>
        <th>Brezhibnost</th>
      </tr>

      <tr>
        <th>05.10.2019</th>
        <td>Redni tehnični pregled</td>
        <td>brezhiben</td>
      </tr>

      <tr>
        <th>16.10.2018</th>
        <td>Redni tehnični pregled</td>
        <td>brezhiben</td>
      </tr>

      <tr>
        <th>02.10.2017</th>
        <td>Redni tehnični pregled</td>
        <td>brezhiben</td>
      </tr>

      <tr>
        <th>26.02.2016</th>
        <td>Redni tehnični pregled</td>
        <td>brezhiben</td>
      </tr>

      <tr>
        <th>02.03.2015</th>
        <td>Redni tehnični pregled</td>
        <td>brezhiben</td>
      </tr>

      <tr>
        <th>02.03.2015</th>
        <td>Redni tehnični pregled</td>
        <td className="warning">
          ni brezhiben
          <span className="new badge red">!</span>
        </td>
      </tr>
    </tbody>
  </table>
)

export default PreglediTable
